import type { CSVColumn, CSVOptions } from './types'

const DEFAULT_OPTIONS: CSVOptions = {
  delimiter: ',',
  filename: 'export.csv'
}

export const generateCSV = (
  data: any[],
  columns: CSVColumn[],
  options: CSVOptions = {}
) => {
  const { delimiter, filename } = { ...DEFAULT_OPTIONS, ...options }

  // Create header row
  const header = columns.map((col) => `"${col.label}"`).join(delimiter)

  // Create data rows
  const rows = data.map((row) =>
    columns
      .map((col) => {
        const value = col.getValue(row)
        return typeof value === 'string' ? `"${value}"` : value
      })
      .join(delimiter)
  )

  // Combine all rows
  const csv = [header, ...rows].join('\n')

  // Create and download file
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}
